import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { CachePolicies } from "use-http";

import { JANZU_URL } from "config/config";
import { useFetchCustom } from "hooks/useFetchCustom";
import { Typography } from "new-components/typography/Typography";
import { ListResponse } from "types/api";
import { Disagreement } from "types/disagreements";


export interface OpenDisagreementButtonProps {
  detectorId: string;
}

export function OpenDisagreementButton(props: OpenDisagreementButtonProps) {
  const { detectorId } = props;

  const disagreementsUrl = `${JANZU_URL}reef-api/disagreements`;
  const { data: disagreementsData, get: getDisagreements } = useFetchCustom<ListResponse<Disagreement>>(
    disagreementsUrl,
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  useEffect(() => {
    if (detectorId) {
      getDisagreements(`?detector_id=${detectorId}&state=OPEN`);
    }
  }, [detectorId, getDisagreements]);

  return (
    <Link to={`/reef/disagreements?detector_id=${detectorId}`}>
      <Box
        component="button"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        px={4}
        py={1}
        sx={{
          cursor: "pointer",
          gap: 2,
          transition: "duration-100 ease-in",
          shadow: "md",
          text: "black",
          bg: "#E5E9ED",
          hover: {
            bg: "#15121A",
          },
        }}
        className="rounded-md group"
      >
        {disagreementsData && disagreementsData?.count > 0 && (
          <Box className="rounded-full flex justify-center items-center p-[2px]">
            <NotificationsActiveIcon className="text-[#006DD9] group-hover:text-[#FFF]" />
          </Box>
        )}

        <Typography variant="subtitle" fontWeight="semibold" textTransform="uppercase" className="group-hover:text-[#FFF]">
          Disagreements
        </Typography>
      </Box>
    </Link>
  );
}
